<template>
    <v-app>
        <v-app-bar app flat>
            <v-icon @click="preMenu" v-if="arrowFlag">mdi-arrow-left</v-icon>
            <v-row>
                <v-col style="text-align: center">
                    {{ title }}
                </v-col>
            </v-row>
        </v-app-bar>
        <v-content class="mb-12">
            <v-container fluid>
            <router-view></router-view>
            </v-container>
        </v-content>
        <v-bottom-navigation
            v-model="bottomNav"
            flat
            dark
            shift
            fixed
        >
            <v-btn value="marketAdd">
                <span>添加线索</span>
                <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn value="marketMain">
                <span>查看线索</span>
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-app>
</template>
<script>
import customElement from "@/plugins/element"
    export default {
        data() {
            return {
                bottomNav:"marketAdd",
                title:"添加线索",
                arrowFlag:false,
            }

        },
        created() {
            this.$router.push("marketAdd")
        },
        watch:{
            bottomNav(newValue){
                if(newValue == "marketAdd"){
                    this.title = "添加线索"
                    this.arrowFlag = false
                }
                else{
                    this.title = "线索"
                    this.arrowFlag = false
                }
                this.$router.push(newValue)
            },
        },
        mounted() {
            this.$publish.unsubscribe('updateTitle')

            this.$publish.subscribe('updateTitle',(msg,title)=>{
                this.title = title
            });

            this.$publish.unsubscribe('updateArrow')
            this.$publish.subscribe('updateArrow',(msg,flag)=>{
                this.arrowFlag = flag
            });
        },
        computed: {
            color () {
                switch (this.bottomNav) {
                    case "marketAdd": return 'blue-grey'
                    case "marketList": return 'teal'
                }
            },
        },
        methods: {
            preMenu(){
                this.$router.back()
                if(this.title == "查看详情"){
                    this.title = "线索"
                    this.arrowFlag = false
                }else if(this.title == "编辑线索"){
                    this.title = "查看详情"
                }
            },
        },
        components: {
            customElement
        },
    }
</script>
<style>
</style>

